module.exports = __webpack_public_path__ + "media/images/icons/outlined/control-7d4a761d4832c2cb95abbc72819149d8.svg";